// extracted by mini-css-extract-plugin
module.exports = {"darkBackground":"PrivacyPromise_darkBackground__vpelA","mainTitle":"PrivacyPromise_mainTitle__9E7D5","subTitle":"PrivacyPromise_subTitle__xYR67"};